import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, OutlinedInput, Paper, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import { TablePaginationActions } from '../../../helpers/TablePaginationActions';

import { usePages } from '../../../hooks/usePages';

import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { TableTheadStyle, TablePaddingStyle } from '../../../styles/TableStyle';
import { DialogContentStyle, DialogActionsStyle } from '../../../styles/DialogStyle';

import { GuardarAnexos } from '../../../connections/audiencias/AudienciaConnection';
import { ObtenerTipoAnexo } from '../../../connections/catalogos/TipoAnexoConnection';
import { ObtenerTipoFormato } from '../../../connections/catalogos/TipoFormatoConnection';

import { AnexoProps, defaultAnexo } from '../../../interfaces/comun/AnexoInterface';
import { TipoAnexoProps } from '../../../interfaces/catalogos/TipoAnexoInterface';
import { TipoFormatoProps } from '../../../interfaces/catalogos/TipoFormatoInterface';
import { AudienciaProps } from '../../../interfaces/audiencias/AudienciaInterface';

interface Props {
    audiencia:      AudienciaProps;
    anexos:         AnexoProps[];
    edit?:          boolean;
    setAnexos?:     React.Dispatch<React.SetStateAction<AnexoProps[]>>;
}

export const Anexos = ({ audiencia, anexos, edit = true, setAnexos }: Props) => {

    const dispatch = useDispatch( )

    const [loading, setLoading] = useState( false );

    const [tipoAnexoArray, setTipoAnexoArray] = useState<TipoAnexoProps[]>( [] );

    const [autocompleteValue, setAutocompleteValue] = useState<TipoAnexoProps | null>( null );
    const [autocompleteValueEdit, setAutocompleteValueEdit] = useState<TipoAnexoProps | null>( null );

    const [tipoFormato, setTipoFormato] = useState( 0 );
    const [tipoFormatoEdit, setTipoFormatoEdit] = useState( 0 );
    const [tipoFormatoArray, setTipoFormatoArray] = useState<TipoFormatoProps[]>( [] );

    const [cantidad, setCantidad] = useState( 1 );
    const [cantidadEdit, setCantidadEdit] = useState( 1 );

    const [numeroFojas, setNumeroFojas] = useState( 1 );
    const [numeroFojasEdit, setNumeroFojasEdit] = useState( 1 );

    const [observaciones, setObservaciones] = useState( '' );
    const [observacionesEdit, setObservacionesEdit] = useState( '' );

    const [openConfirmacion, setOpenConfirmacion] = useState( false );
    const [openEdit, setOpenEdit] = useState( false );

    const [anexoSelected, setAnexoSelected] = useState<AnexoProps>( defaultAnexo );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages(5);

    const handleAgregar = () => {

        if ( !setAnexos ) return;

        const id = new Date().getUTCSeconds() + '' + new Date().getUTCMilliseconds();

        const tipoFormatoData = tipoFormatoArray.find((e) => e.idTipoFormato === tipoFormato);

        const data: AnexoProps = {
            id:             parseInt(id),
            idTipoAnexo:    autocompleteValue?.idTipoAnexo ?? 0,
            tipoAnexo:      autocompleteValue?.descripcion ?? '',
            idTipoFormato:  tipoFormato,
            tipoFormato:    tipoFormatoData?.descripcion ?? '',
            cantidad:       cantidad,
            numeroFojas:    numeroFojas,
            observaciones:  observaciones
        };

        setAnexos([ ...anexos, data ]);

        setTipoFormato( 0 );
        setCantidad( 1 );
        setNumeroFojas( 1 );
        setObservaciones( '' );
        setAutocompleteValue( null );

    }

    const handleClicEditarAnexo = () => {

        if ( !setAnexos ) return;

        const tipoFormatoData = tipoFormatoArray.find( ({ idTipoFormato }) => idTipoFormato === tipoFormatoEdit );

        var newArray = anexos.filter( ({ id }) => id !== anexoSelected.id );
        var editRow = anexos.find( ({ id }) => id ===  anexoSelected.id  );

        if ( editRow ) {

            var data: AnexoProps = {
                ...editRow,
                idTipoAnexo: autocompleteValueEdit?.idTipoAnexo ?? 0,
                tipoAnexo: autocompleteValueEdit?.descripcion ?? '',
                idTipoFormato: tipoFormatoData?.idTipoFormato ?? 0,
                tipoFormato: tipoFormatoData?.descripcion ?? '',
                cantidad: cantidadEdit,
                numeroFojas: numeroFojasEdit,
                observaciones: observacionesEdit ?? '',
            };

            setAnexos([ ...newArray, data ]);
            setOpenEdit( false );
        }

    }

    const handleClicRemoverAnexo = () => {

        if ( !setAnexos ) return;

        setAnexos( anexos.filter( ({ id }) => id !==  anexoSelected.id ) );

        setOpenConfirmacion(false);

    }

    const handleActualizarAnexos = async () => {

        setLoading( true );

        await GuardarAnexos({ idAudiencia: audiencia.idAudiencia, anexos }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch( openSnackbar({ message: message, variant: 'success' }) );
                    setLoading( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoading( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoAnexo().then( resp => {

                setTipoAnexoArray( resp );

            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoFormato().then( resp => {

                setTipoFormatoArray( resp );

            });

        }

        Obtener();

    }, []);

    return (
        <Box p={ 4 } component={ Paper }>

            <Grid container spacing={ 3 }>

                {
                    edit
                    &&
                        <>

                            <Grid size={{ md: 4, xs: 12 }} >

                                <FormControl fullWidth>

                                    <Autocomplete

                                        fullWidth
                                        value={ autocompleteValue }
                                        options={ tipoAnexoArray }
                                        onChange={ (event, value) => setAutocompleteValue( value ) }
                                        getOptionLabel={ (option) => option.descripcion }
                                        renderOption={(props, option) => (
                                            <li {...props} key={ option.idTipoAnexo } style={{ paddingTop: 10, paddingBottom: 10, }}>
                                                {option.descripcion}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} label="Tipo de anexo" placeholder='Seleccione una opción' slotProps={{ inputLabel: { shrink: true, } }} />}
                                    />

                                </FormControl>

                            </Grid>

                            <Grid size={{ md: 4, xs: 12 }}>

                                <FormControl fullWidth>

                                    <InputLabel>Tipo de formato</InputLabel>

                                    <Select
                                        label="Tipo de formato"
                                        value={ tipoFormato }
                                        onChange={ (e) => setTipoFormato(e.target.value) }
                                    >
                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                        {
                                            tipoFormatoArray.map(({ idTipoFormato, descripcion }) => (
                                                <MenuItem key={ idTipoFormato } value={ idTipoFormato }>{descripcion}</MenuItem>
                                            ))
                                        }
                                    </Select>

                                </FormControl>

                            </Grid>

                            <Grid size={{ md: 2, xs: 12 }} >

                                <FormControl>

                                    <InputLabel shrink>Cantidad</InputLabel>
                                    <OutlinedInput
                                        fullWidth
                                        label="Cantidad"
                                        type="number"
                                        value={ cantidad }
                                        onChange={ (e) => {
                                            if ( e.target.value === '') {
                                                setCantidad( 0 );
                                            }
                                            else {
                                                setCantidad( parseInt(e.target.value.toString() ?? '0' ) );
                                            }
                                        }}
                                        slotProps={{ input: { min: 1 } }}
                                    />

                                </FormControl>

                            </Grid>

                            <Grid size={{ md: 2, xs: 12 }} >

                                <FormControl>

                                    <InputLabel shrink>Número de fojas</InputLabel>
                                    <OutlinedInput
                                        fullWidth
                                        label="Número de fojas"
                                        type="number"
                                        value={ numeroFojas }
                                        onChange={ (e) => {
                                            if ( e.target.value === '' ) {
                                                setNumeroFojas( 0 );
                                            }
                                            else {
                                                setNumeroFojas( parseInt( e.target.value.toString() ?? '0' ) );
                                            }
                                        }}
                                        slotProps={{ input: { min: 1 } }}
                                    />

                                </FormControl>

                            </Grid>

                            <Grid size={{ md: 10, xs: 12 }} >

                                <TextField
                                    fullWidth
                                    label="Observaciones"
                                    variant="outlined"
                                    multiline
                                    rows={ 4 }
                                    value={ observaciones }
                                    onChange={ (e) => setObservaciones(e.target.value) }
                                />

                            </Grid>

                            <Grid size={{ md: 2, xs: 12 }}>

                                <Button
                                    fullWidth
                                    variant="contained"
                                    disabled={ ( autocompleteValue?.idTipoAnexo ?? 0 ) === 0 || tipoFormato === 0 }
                                    onClick={ handleAgregar }
                                >
                                    Agregar
                                </Button>

                            </Grid>

                        </>
                }

                <Grid size={{ md: 12, xs: 12 }} >

                    <TableContainer sx={{ borderRadius: 3, mt: 1 }}>

                        <Table sx={{ minWidth: 500 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%' }}>Tipo de anexo</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%' }}>Tipo de formato</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}>Cantidad</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}>Número de fojas</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '25%' }}>Observaciones</TableCell>

                                    { edit && <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}> </TableCell> }

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    (
                                        rowsPerPage > 0
                                        ? anexos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        : anexos
                                    ).map(( elem, index) => {

                                        const { idTipoAnexo, tipoAnexo, idTipoFormato, tipoFormato, cantidad, numeroFojas, observaciones } = elem;

                                        return <TableRow key={ index }>

                                            <TableCell>{ tipoAnexo }</TableCell>

                                            <TableCell>{ tipoFormato }</TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>{ cantidad }</TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>{ numeroFojas }</TableCell>

                                            <TableCell>{ observaciones }</TableCell>

                                            {
                                                edit
                                                &&
                                                    <TableCell sx={{ textAlign: 'end' }}>

                                                        <IconButton
                                                            color="primary"
                                                            onClick={ () => {

                                                                var tipoAnexoFind = tipoAnexoArray.find((e) => e.idTipoAnexo === idTipoAnexo);

                                                                if ( tipoAnexoFind ) {
                                                                    setAutocompleteValueEdit( tipoAnexoFind );
                                                                }

                                                                setTipoFormatoEdit( idTipoFormato );
                                                                setCantidadEdit( cantidad );
                                                                setNumeroFojasEdit( numeroFojas );
                                                                setObservacionesEdit( observaciones ?? '' );
                                                                setAnexoSelected( elem );

                                                                setOpenEdit( true );
                                                            }}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>

                                                        <IconButton color="primary" onClick={ () => { setAnexoSelected( elem ); setOpenConfirmacion( true ); }}>
                                                            <DeleteIcon />
                                                        </IconButton>

                                                    </TableCell>
                                            }

                                        </TableRow>

                                    })
                                }

                                {
                                    anexos.length === 0
                                    &&
                                        <TableRow>

                                            <TableCell
                                                colSpan={ 7 }
                                                align="center"
                                            >
                                                <Typography variant="caption" color='secondary'> No se agregaron anexo(s) </Typography>

                                            </TableCell>

                                        </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TablePagination
                                        rowsPerPageOptions={ [] }
                                        colSpan={ 6 }
                                        count={ anexos.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

                {
                    edit
                    &&
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right' }}> </Grid>

                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'center' }}>

                                    <Button
                                        fullWidth
                                        variant="contained"
                                        loading={ loading }
                                        onClick={ handleActualizarAnexos }
                                    >
                                        Guardar
                                    </Button>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'left' }}> </Grid>

                            </Grid>

                        </Grid>
                }

                <Dialog
                    fullWidth
                    maxWidth='sm'
                    open={ openEdit }
                    onClose={ () => {} }
                >

                    <DialogTitle>
                        Editar
                    </DialogTitle>

                    <DialogContent sx={ DialogContentStyle }>

                        <Grid container spacing={ 3 } mt={ 1 }>

                            <Grid size={{ md: 12, xs: 12 }} >

                                <FormControl fullWidth>

                                    <Autocomplete

                                        fullWidth
                                        value={ autocompleteValueEdit }
                                        options={ tipoAnexoArray }
                                        onChange={ (event, value) => setAutocompleteValueEdit( value ) }
                                        getOptionLabel={ (option) => option.descripcion }
                                        renderOption={(props, option) => (
                                            <li {...props} key={ option.idTipoAnexo } style={{ paddingTop: 10, paddingBottom: 10, }}>
                                                {option.descripcion}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} label="Tipo de anexo" placeholder='Seleccione una opción' slotProps={{ inputLabel: { shrink: true, } }} />}
                                    />

                                </FormControl>

                            </Grid>

                            <Grid size={{ md: 12, xs: 12 }} >

                                <FormControl fullWidth>

                                    <InputLabel>Tipo de formato</InputLabel>

                                    <Select
                                        label="Tipo de formato"
                                        value={ tipoFormatoEdit }
                                        onChange={ (e) => setTipoFormatoEdit( e.target.value ) }
                                    >
                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                        {
                                            tipoFormatoArray.map(({ idTipoFormato, descripcion }) => (
                                                <MenuItem key={ idTipoFormato } value={ idTipoFormato }>{descripcion}</MenuItem>
                                            ))
                                        }
                                    </Select>

                                </FormControl>

                            </Grid>

                            <Grid size={{ md: 6, xs: 12 }} >

                                <FormControl fullWidth>

                                    <InputLabel shrink>Cantidad</InputLabel>
                                    <OutlinedInput
                                        fullWidth
                                        label="Cantidad"
                                        type="number"
                                        value={ cantidadEdit }
                                        onChange={ (e) => {
                                            if ( e.target.value === '' ) {
                                                setCantidadEdit( 0 );
                                            }
                                            else {
                                                setCantidadEdit( parseInt( e.target.value.toString() ?? '0' ) );
                                            }
                                        }}
                                        slotProps={{ input: { min: 1 } }}
                                    />

                                </FormControl>

                            </Grid>

                            <Grid size={{ md: 6, xs: 12 }} >

                                <FormControl fullWidth>

                                    <InputLabel shrink>Número de fojas</InputLabel>
                                    <OutlinedInput
                                        fullWidth
                                        label="Número de fojas"
                                        type="number"
                                        value={ numeroFojasEdit }
                                        onChange={ (e) => {
                                            if ( e.target.value === '' ) {
                                                setNumeroFojasEdit( 0 );
                                            }
                                            else {
                                                setNumeroFojasEdit( parseInt(e.target.value.toString() ?? '0' ) );
                                            }
                                        }}
                                        slotProps={{ input: { min: 1 } }}
                                    />

                                </FormControl>

                            </Grid>

                            <Grid size={{ md: 12, xs: 12 }} >

                                <TextField
                                    fullWidth
                                    label="Observaciones"
                                    variant="outlined"
                                    multiline
                                    rows={ 4 }
                                    value={ observacionesEdit }
                                    onChange={ (e) => setObservacionesEdit( e.target.value ) }
                                />

                            </Grid>

                        </Grid>

                    </DialogContent>

                    <DialogActions sx={ DialogActionsStyle }>

                        <Button color='secondary' onClick={ () => setOpenEdit( false ) }> Cancelar </Button>
                        <Button
                            variant='contained'
                            onClick={ handleClicEditarAnexo }
                            disabled={
                                autocompleteValueEdit === null ||
                                tipoFormatoEdit === 0 ||
                                cantidadEdit < 1 ||
                                numeroFojasEdit < 1
                            }
                        >
                            Guardar
                        </Button>

                    </DialogActions>
                </Dialog>

                <Dialog
                    fullWidth
                    maxWidth='xs'
                    open={ openConfirmacion }
                    onClose={ () => {} }
                >

                    <DialogTitle>
                        Confirmación
                    </DialogTitle>

                    <DialogContent sx={ DialogContentStyle }>

                        <DialogContentText>
                            ¿Desea quitar el registro seleccionado?
                        </DialogContentText>

                    </DialogContent>

                    <DialogActions sx={ DialogActionsStyle }>

                        <Button color='secondary' onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>
                        <Button onClick={ handleClicRemoverAnexo } variant='contained' > Aceptar </Button>

                    </DialogActions>

                </Dialog>

            </Grid>

        </Box>
    )
}
